import React from 'react';
import AirlineDetailPage from '../components/AirlineDetailPage';
import { ICELANDAIR } from '../data/airlinesData';

export default function IcelandairPage() {
  return <AirlineDetailPage airline={ICELANDAIR} />;
}
